import { FC, useEffect, useMemo, useState } from 'react';
import styled, { css } from 'styled-components';
import { Autoplay } from 'swiper';
import { SwiperSlide, Swiper } from 'swiper/react';

const logos = [
  { src: '/new/biz/logos/logo1.png' },
  { src: '/new/biz/logos/logo2.png' },
  { src: '/new/biz/logos/logo3.png' },
  { src: '/new/biz/logos/logo4.png' },
  { src: '/new/biz/logos/logo5.png' },
  { src: '/new/biz/logos/logo6.png' },
  { src: '/new/biz/logos/logo7.png' },
  { src: '/new/biz/logos/logo8.png' },
  { src: '/new/biz/logos/logo9.png' },
  { src: '/new/biz/logos/logo10.png' },
  { src: '/new/biz/logos/logo11.png' },
];
const Section4: FC = () => {
  return (
    <L_Section4Container>
      <RollingBanner />
    </L_Section4Container>
  );
};
const L_Section4Container = styled.section`
  padding-bottom: 6rem;
`;
const RollingBanner = () => {
  const [width, setWidth] = useState(960);
  const isMobile = useMemo(() => width <= 1024, [width]);
  useEffect(() => {
    const callback = () => {
      setWidth(window.outerWidth);
    };
    callback();
    window.addEventListener('resize', callback);
    return () => {
      window.removeEventListener('resize', callback);
    };
  }, []);
  return (
    <L_RollingBanner>
      <Swiper
        spaceBetween={50}
        slidesPerView={isMobile ? 2 : 3}
        autoplay={{ delay: 0, stopOnLastSlide: false }}
        speed={3000}
        allowTouchMove={false}
        loop
        modules={[Autoplay]}
      >
        {[logos, logos, logos, logos, logos, logos].flat(1).map(({ src }, i) => (
          <SwiperSlide key={i}>
            <>
              <RollingBannerImage src={src} alt={src} />
              <RollingBannerAbsoluteWrapper>
                <RollingBannerImage isShow src={src} alt={src} />
              </RollingBannerAbsoluteWrapper>
            </>
          </SwiperSlide>
        ))}
      </Swiper>
      <BackdropRight />
      <BackdropLeft />
    </L_RollingBanner>
  );
};
const RollingBannerAbsoluteWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;
const RollingBannerImage = styled.img<{ isShow?: boolean }>`
  height: 6rem;
  object-fit: contain;
  width: fit-content;
  ${({ isShow }) =>
    isShow
      ? css`
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        `
      : 'opacity:0'};
`;
const BackdropRight = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;

  z-index: 2;
  width: 10rem;
  @media (max-width: 1024px) {
    display: none;
  }
`;
const BackdropLeft = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;

  z-index: 2;
  width: 10rem;
  @media (max-width: 1024px) {
    display: none;
  }
`;
const L_RollingBanner = styled.div`
  .swiper-wrapper {
    transition-timing-function: linear;
  }
  display: flex;
  max-width: 1024px;
  margin: 0 auto;
  position: relative;
`;

export default Section4;
